import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { FullComponent } from './layout/full.component';
import { LoginComponent } from './login/login/login.component';
import { HomeComponent } from './home/home.component';
import { AuthorizatedGuard } from './core/guards/authorizated.guard';


const routes: Routes = [
  {
    path: '',
    redirectTo: 'inicio',
    pathMatch: 'full',
  },
  {
    path: '',
    component: FullComponent,
    canActivate: [AuthorizatedGuard],
    children: [
      {
        path: 'dashboard',
        loadChildren: () => import('./modules/dashboard/dashboard.module').then(m => m.DashboardModule)
      },
      {
        path: 'seguridad',
        loadChildren: () => import('./modules/seguridad/seguridad.module').then(m => m.SeguridadModule)
      },
      {
        path: 'cliente',
        loadChildren: () => import('./modules/clientes/clientes.module').then(m => m.PedidosModule)
      },
      {
        path: 'administracion',
        loadChildren: () => import('./modules/administracion/administracion.module').then(m => m.AdministracionModule)
      },
      {
        path: 'inventario',
        loadChildren: () => import('./modules/inventario/inventario.module').then(m => m.InventarioModule)
      },
      {
        path: 'consignacion',
        loadChildren: () => import('./modules/Consignacion/compensacion.module').then(m => m.ConsignacionModule)
      }

    ]
  },
  {
    path: 'login/:tipoLogueo',
    component: LoginComponent
  },


  {
    path: 'inicio',
    component: HomeComponent
  },


];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: true })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
